import React from 'react';
import { Icon, IconProps } from '@chakra-ui/icons';

export const CrossIcon = (props: IconProps) => (
  <Icon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.829346 12.9454L12.8295 0.945435" strokeWidth="1.5px" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.8295 12.9454L0.829346 0.945435" strokeWidth="1.5px" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
